import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function roundNumber(number) {
  return number === 0 ? '00' : (number < 10) ? `0${number}` : number;
}

function msToTime(duration) {
  const milliseconds = parseInt((duration % 1000) / 100);
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = roundNumber(hours);
  minutes = roundNumber(minutes);
  seconds = roundNumber(seconds);

  return `${hours} : ${minutes} : ${seconds}`;
}

const sessionDialog = (props) => {
  const {
    open, timestamp, expiredAt, handleClose,
  } = props;
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
      Session Expired
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
        Logged out due to inactivity
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" style={{ color: '#fff' }} onClick={handleClose} color="primary">
              Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default sessionDialog;
